module.exports = __webpack_public_path__ + "static/july-3-4878bf10d13aca4e18ff73c133d8ab79.png";